module.exports = __webpack_public_path__ + "static/media/output_2.88b1e305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/output_2.png
// module id = 2522
// module chunks = 0